import { render, staticRenderFns } from "./tab_facebook_fanpage.vue?vue&type=template&id=73ae56ed"
import script from "./tab_facebook_fanpage.vue?vue&type=script&lang=js"
export * from "./tab_facebook_fanpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports